/* eslint-disable react/no-array-index-key */
import * as React from 'react';
import withStyles from 'react-jss';
import { styles } from './ChatComponent.styles';
import { Button, Form, Select } from 'antd';
import { MinusCircleOutlined } from '@ant-design/icons';
import ImageUpload from './ImageUpload';
import { useTranslation } from 'react-i18next';

const AttachFiles = (props: any) => {
  const VALID_FILE_TYPES = '.xlsx, .xls, .csv, .pdf, .png, .jpeg, .docx, .doc, .jpg';
  const { t } = useTranslation();

  const FileUploadWithFileType = (props: any) => {
    const { onChange, value = {}, key } = props;
    const onChangeFileType = (fileType) => {
      onChange({ ...value, fileType });
    };

    const [filesList, setFilesList] = React.useState({}) as any;
    const [docUrlsList, setDocUrlsList] = React.useState({}) as any;
    const [fieldValues, setFieldValues] = React.useState([]);

    React.useEffect(() => {
      if (filesList) {
        const files = filesList?.chat_document || [];
        const url = docUrlsList?.chat_document;
        onChange({
          ...value,
          name: files[0]?.name,
          size: files[0]?.size,
          contentType: files[0]?.type,
          type: files[0]?.name?.split('.')[1],
          url,
          id: files[0]?.uid,
        });
      }
    }, [filesList, docUrlsList]);

    return (
      <div style={{ display: 'flex', width: '90%' }}>
        <div style={{ width: '50%', marginRight: '20px' }}>
          <Select
            placeholder="File Type"
            onChange={onChangeFileType}
            style={{ flexGrow: 1 }}
            value={value.fileType}
            options={props.fileTypeOptions}
          />
        </div>
        {value.fileType && (
          <div style={{ width: '50%' }}>
            <ImageUpload
              documentId="chat_document"
              filesList={filesList}
              setFilesList={setFilesList}
              setDocUrlsList={setDocUrlsList}
              docUrlsList={docUrlsList}
              fieldValues={fieldValues}
              setFieldValues={setFieldValues}
              documentType="chat_document"
              hideUploadButton
              restrictFileSize
              fileSizeLimit={3}
              {...props}
              viewConfig={{
                uploadProps: {
                  accept: VALID_FILE_TYPES,
                },
              }}
            />
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      <div style={{ marginBottom: '5px', fontWeight: 600, fontSize: '12px' }}>{t('File Type')}</div>
      <Form.List name="attachments" initialValue={[{ key: 0, name: 0 }]}>
        {(fields, { add, remove }, { errors }) => (
          <>
            {fields.map((field, index) => (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '10px',
                }}
                key={field.name}
              >
                <Form.Item
                  style={{
                    marginBottom: '0px',
                    flexGrow: 1,
                    display: 'flex',
                  }}
                  required={false}
                  key={index}
                  name={[field.name, 'file']}
                >
                  <FileUploadWithFileType {...props} />
                </Form.Item>
                {fields.length > 1 ? (
                  <Button icon={<MinusCircleOutlined />} onClick={() => remove(field.name)} />
                ) : null}
              </div>
            ))}
            <Form.Item>
              <Form.ErrorList errors={errors} />
            </Form.Item>
          </>
        )}
      </Form.List>
    </div>
  );
};

export default withStyles(styles, {
  injectTheme: true,
})(
  React.memo(AttachFiles, () => {
    return true;
  }),
);
